<template>
<v-container fluid fill-height>
    <v-layout justify-center>
        <v-responsive max-width="1024px" width="100%" height="100%">
            <v-row class="mt-4">
                <v-col cols="12" md="6">
                    <v-card>
                        <v-toolbar color="info lighten-1" dense>
                            <v-toolbar-title class="white--text subtitle-2">카테고리</v-toolbar-title>

                            <v-spacer></v-spacer>
                            <v-dialog v-model="dialog" width="500">
                                <template v-slot:activator="{ on }">
                                    <v-fab-transition>
                                        <v-btn color="accent" fab dark absolute bottom right v-on="on">
                                            <v-icon>mdi-plus</v-icon>
                                        </v-btn>
                                    </v-fab-transition>
                                </template>

                                <v-card>
                                    <v-card-title class="headline" primary-title>
                                        신규 카테고리 등록
                                    </v-card-title>

                                    <v-card-text>
                                        <v-row>
                                            <v-col>
                                                <shop-category-select v-if="categories" v-model="editItem.parent" :categories="categories"></shop-category-select>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col>
                                                <v-text-field v-model="editItem.name" label="카테고리 이름"></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col>
                                                <v-text-field v-model="editItem.code" label="카테고리 코드"></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col>
                                                사용할필터
                                                <v-switch
                                                v-for="item in editItem.filters"
                                                :label="item.name"
                                                v-model="item.use"
                                                ></v-switch>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>

                                    <v-divider></v-divider>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="primary" text @click="save">
                                            등록
                                        </v-btn>
                                        <v-btn color="primary" text @click="dialog = false">
                                            취소
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-toolbar>

                        <v-card-text>
                            <v-draggable-treeview v-if="categories.length" v-model="categories" item-key="_id" children="children" group="categories" @click="select" dense></v-draggable-treeview>
                            <span v-else>등록된 카테고리가 없습니다.<br>카테고리를 등록해주세요</span>
                        </v-card-text>

                    </v-card>

                    <v-row>
                        <v-spacer></v-spacer>
                        <v-col md="auto">

                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" md="6">
                    <v-card :disabled="!category._id">
                        <v-card-text>
                            <v-row>
                                <v-col>
                                    <v-text-field v-model="category.code" label="카테고리 코드(영문)"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-text-field v-model="category.name" label="카테고리 이름"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    사용할필터
                                    <v-switch
                                    v-for="item in category.filters"
                                    :label="item.name"
                                    v-model="item.use"
                                    ></v-switch>
                                </v-col>
                            </v-row>

                            <!-- <v-row>
                                <v-col cols="auto" class="pt-0 pb-0">
                                    <v-img v-if="category.icon" :src="iconChange ? createObjectURL(category.icon) : `/${category.icon.path}`" width="128" height="128"></v-img>
                                    <v-responsive v-else width="128" height="128">
                                        <v-row class="fill-height ma-0 grey lighten-3" align="center" justify="center">
                                            <v-icon>mdi-image</v-icon>
                                        </v-row>
                                    </v-responsive>
                                </v-col>
                                <v-col>
                                    <v-file-input v-model="category.icon" label="d" show-size accept="image/*" @change="iconChange=true;"></v-file-input>
                                </v-col>
                            </v-row> -->

                            <v-row>
                                <v-col>
                                    <v-textarea v-model="category.svg" label="svg 태그"></v-textarea>
                                </v-col>
                            </v-row>

                            <!-- <v-row>
                                <v-col>
                                    <v-radio-group v-model="category.type" label="카테고리 유형" dense hide-details>
                                        <v-radio label="리스트" value="banner" class="mt-0"></v-radio>
                                        <v-radio label="상세페이지" value="details" class="mt-0"></v-radio>
                                    </v-radio-group>
                                </v-col>
                            </v-row> -->
                            <v-row>
                                <v-col md="auto">
                                    <v-btn color="grey darken-1" class="white--text" @click="remove(category)" :disabled="category.root ? true : false">삭제</v-btn>
                                </v-col>
                                <v-spacer></v-spacer>
                                <v-col md="auto">
                                    <v-btn color="primary" @click="update(category)">저장</v-btn>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-responsive>
    </v-layout>

</v-container>
</template>

<script>
import api from "@/api";
import ShopCategorySelect from '@/components/console/portfolio/category/portfolio-category-select.vue';

export default {
    components: {
        ShopCategorySelect
    },
    created() {
        this.init();
    },
    data: () => {
        return {
            dialog: false,
            loading: true,
            headers: [],
            categories: [],
            category: {},
            iconChange : false,
            editItem: {
                parent: null,
                name: "",
                no: 0,
                type: "",
                filters : [
                    {"name" : "시공전후" , "use" : false},
                    {"name" : "평수" , "use" : false},
                    {"name" : "비용" , "use" : false},
                    {"name" : "컨셉" , "use" : false},
                    {"name" : "컬러" , "use" : false}
                ]
            },
            defaultItem: {
                parent: null,
                name: "",
                no: 0,
                type: "",
                filters : [
                    {"name" : "시공전후" , "use" : false},
                    {"name" : "평수" , "use" : false},
                    {"name" : "비용" , "use" : false},
                    {"name" : "컨셉" , "use" : false},
                    {"name" : "컬러" , "use" : false}
                ]
            },

        };
    },
    methods: {
        createObjectURL(file){
            try{ return URL.createObjectURL(file); }
            catch(error){}
        },
        async init(){
            try{
                await this.search();

                this.$nextTick(() => { this.loading = false; });
            }
            catch(error){
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },
        async search(){
            try{
                var { categories } = await api.console.portfolios.categories.getCategories();
                this.categories = categories;
            }
            catch(error){
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },
        /////////////////////////////////////////
        // 카테고리 등록
        /////////////////////////////////////////
        save() {
            return new Promise(async (resolve, reject) => {
                try {
                    this.loading = true;

                    var _category = await api.console.portfolios.categories.postCategory({
                        _parents: this.editItem.parent ? [].concat(this.editItem.parent._parents, this.editItem.parent._id) : [],
                        depth: this.editItem.parent ? this.editItem.parent.depth + 1 : 1,
                        name: this.editItem.name,
                        code: this.editItem.code,
                        type: this.editItem.type,
                        filters : this.editItem.filters
                    });

                    // var parent = this.editItem.category;
                    //
                    // if (parent) {
                    //     parent._categories.push(_category);
                    //     await this.putCategory(parent);
                    // }

                    await this.search();
                    this.dialog = false;

                    resolve();
                } catch (error) {
                    console.log(error);
                    reject(error);
                }
            })
        },

        /////////////////////////////////////////
        // 카테고리 수정
        /////////////////////////////////////////
        update(category) {
            return new Promise(async (resolve, reject) => {
                try {
                    await api.console.portfolios.categories.putCategory(category);
                    await this.search();

                    resolve();
                } catch (error) {
                    reject(error);
                }
            });
        },
        /////////////////////////////////////////
        // 카테고리 삭제
        /////////////////////////////////////////
        remove(category) {
            return new Promise(async (resolve, reject) => {
                try {
                    if(confirm("카테고리를 삭제하시겠습니까?")){
                        await api.console.portfolios.categories.deleteCategory(category);
                        await this.search();

                        this.category = JSON.parse(JSON.stringify(this.defaultItem));
                    }

                    resolve();
                } catch (error) {
                    reject(error);
                }
            });
        },
        findParent(category, parent) {
            for (var i in parent.categories) {
                if (parent.categories[i] == category) return parent;
                if (parent.categories[i].categories) {
                    var result = this.findParent(category, parent.categories[i]);
                    if (result) return result;
                }
            }
            return null;
        },
        select(category) {
            this.category = category;
        },
        sort(categories, _parents = [], depth = 1) {
            for(var i in categories) {
                var category = categories[i];
                category.sequence = i;
                category.depth = depth;
                category._parents = _parents;

                if (category.children) {
                    category._children = category.children.map((child) => { return child._id });
                    this.sort(category.children, [].concat(category._parents, category._id), depth + 1);
                }
                api.console.portfolios.categories.putCategory(category);
            }
        }
    },
    computed: {},
    watch: {
        category() {
            console.log(this.category);
        },
        categories() {
            if (!this.loading) {
                this.sort(this.categories);
            }
        }
    }
}
</script>
